/**
 * @description 导出通用配置
 */
module.exports = {
  // 标题，此项修改后需要重启项目！！！ (包括初次加载雪花屏的标题 页面的标题 浏览器的标题)
  title: '案例云',
  // 标题分隔符
  titleSeparator: ' - ',
  // 简写
  abbreviation: '案例云',
  // pro版本copyright可随意修改
  copyright: '案例云',
  routerMode: 'hash',
  // 不经过token校验的路由，白名单路由建议配置到与login页面同级，如果需要放行带传参的页面，请使用query传参，配置时只配置path即可
  routesWhiteList: [
    '/login',
    '/register',
    '/callback',
    '/404',
    '/403',
    '/pay',
    '/passport',
  ],
  // 加载时显示文字
  loadingText: '正在加载中...',
  // token名称
  tokenName: 'Token',
  // token在localStorage、sessionStorage、cookie存储的key的名称
  tokenTableName: 'admin-pro-token',
  // token失效回退到登录页时是否记录本次的路由（是否记录当前tab页）
  recordRoute: true,
  // token存储位置localStorage sessionStorage cookie
  storage: 'localStorage',
  // 是否开启登录拦截
  loginInterception: true,
  // 需要加loading层的请求，防止重复提交
  debounce: ['doEdit'],
}
